import { roundup } from '@/mocks/homeData';

export default function Roundup() {
  return (
    <section id="roundup" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-primary-600 text-xs md:text-sm font-label font-medium tracking-wide">
            <i className="ri-list-ordered" />
            高能盘点
          </p>
          <h2 className="mt-3 font-heading font-bold text-foreground-950 text-2xl md:text-4xl leading-snug">
            编号式盘点，一条一个主题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            高能盘点把零散的材料按主题归档成编号列表，适合一次看完，也方便你记住自己读到哪了。
          </p>
        </div>

        <div className="mt-10 relative">
          <div className="absolute left-[19px] md:left-[23px] top-2 bottom-2 w-px bg-background-300" />
          <div className="flex flex-col gap-7 md:gap-9">
            {roundup.map((item) => (
              <div key={item.id} className="relative flex gap-5 md:gap-7 pl-0">
                <span className="relative z-10 shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50 border border-background-300 flex items-center justify-center font-heading font-bold text-primary-600 text-sm md:text-base">
                  {item.no}
                </span>

                <div className="flex-1 min-w-0 grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-4 items-center border-b border-background-200 pb-7">
                  <div className="min-w-0">
                    <h3 className="font-heading font-semibold text-foreground-950 text-lg md:text-xl leading-snug">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
                    <span className="mt-3 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-label">
                      <i className="ri-folder-line" />
                      {item.count}
                    </span>
                  </div>

                  <div className="w-full h-[140px] sm:w-[130px] sm:h-[130px] rounded-md overflow-hidden shrink-0">
                    <img
                      src={item.image}
                      alt={`${item.title} 黑料大全 高能盘点`}
                      title={`${item.title} - 黑料大全`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}